import axios from 'axios';

const createApi = (baseURL, token) => {
  const instance = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.status === 401) {
        console.error('Unauthorized');
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export const api = createApi(
  process.env.REACT_APP_API_BASE_URL,
  process.env.REACT_APP_API_KEY
);

const createApiCrm = (baseURL, token) => {
  const instance = axios.create({
    baseURL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.status === 401) {
        console.error('Unauthorized');
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export const apiCrm = createApiCrm(
  process.env.REACT_APP_API_CRM_BASE_URL,
  process.env.REACT_APP_API_CRM_KEY
);